import {
    FormGroup,
    TextField,
    Button,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Paper,
    Typography,
    Table,
    TableCell,
    TableBody,
    TableContainer,
    TableRow,
    TableHead,
    Tooltip,
    Switch,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    ListSubheader
  } from "@material-ui/core";
  import { makeStyles } from "@material-ui/core/styles";
  import InfoIcon from '@mui/icons-material/Info';
  import { Dialog } from "@mui/material";
  import GetRole from "./user";
  import { useAppData } from "./appDataContext.js";
  import { useEffect, useRef } from "react";
  import DateCalc from "./date";
  import axios from "axios"
  import useState from 'react-usestateref'
  import {getquality, identifydest, classifyfup, specialoptions, DateCalc2, getquote} from "./date";
  import {
    updateTripdata,
    fetchTripbyId,
    fetchDest,
    fetchquotelist,
    fetchwadata,
    fetchCustomerbyId,
    fetchEmployees,
    fetchEmployeebyName,
    gmailSend,
    searchCustomersbyNumber,
    fetchQuotebyId,
    fetchquotedatesonly,
    makecall
  } from "../api/customerapi";
  import {svtoken} from "../api/customerapi";
  import { red } from "@material-ui/core/colors";
import Reusequote from "./reusequote";
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    icon: {
      align: "center",
      verticalAlign: "middle",
    },
    red: {
      color:red
    },
    checkboxalign: {
      alignSelf: "center",
      justifyContent: "center",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      //color: "red",
    },
    textField3: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    formgroup: {
      justifyContent: "center",
    },
    textArea: {
      marginLeft: theme.spacing(12),
      marginRight: theme.spacing(14),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(25),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    button4: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(75),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    smallbutton: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(10),
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    smallbutton2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(10),
      height: theme.spacing(4),
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(4),
    },
    button3: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(25),
      height: theme.spacing(4),
    },
    input: {
      "&:invalid": {
        border: "red solid 2px"
      }
    },
    headtext: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      
    },
    redheadtext: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      justifyContent:"center",
      border: "red solid 2px"
    },
    bodytext: {
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));

const ProductBased = () => {
    const classes = useStyles();
    const [searchData, setsearchData] = useState({
        dest:"",
        type:"",
        budget:""
    });
    const [tripData, settripData] = useState(null);
    const [showquote, setshowquote] = useState(false);
    const [showspecial, setshowspecial] = useState([]);
    const [showquoteid, setshowquoteid] = useState(false);
    const preURL = document.referrer;
    const urlarray = preURL.split("/");
    const tripid = urlarray[urlarray.length - 1];
    const { appData, loading } = useAppData();

    const getTrip = async (id) => {
        //console.log(id)
        try{
        const data = await fetchTripbyId(id);
        //console.log(data.data)
        settripData(data.data);
        setshowspecial(specialoptions(data.data.primary_destination));
        setsearchData({...searchData, dest:data.data.primary_destination, duration:data.data.duration});
       
      }catch(err){
        console.log(err)
      }
      };

      useEffect(() => {
        getTrip(tripid);
        
      }, []);

      const searchquote=()=>{
        //console.log(searchData)
        const quoteid=getquote(searchData)
        console.log(quoteid)
        setshowquoteid(quoteid)
        setshowquote(true)
      }

    return(
        <div>
       
        {showquote?(
            <Reusequote qid={{id: showquoteid, params: searchData}}/>
        ):(
            <div>
        {/* <p>DEF</p> */}
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        {/*<Typography variant="h6">Dubai FD packages for 6N available in Medium-Generic-FD Packages combination <b>(every Friday including lunch and dinner)</b></Typography>
        <br></br>
        <br></br>
        <Typography variant="h6">Thailand FD packages for 4N available from BOM and BLR (every Wednesday from Apr 1) from 40k net cost</Typography>
        <br></br>
        <br></br>
        <Typography variant="h6">Bali special packages for 5N/6N available in Medium-Generic/Romantic-Special Packages and High-Generic/Romantic-Special Packages combination</Typography>*/}
        <br></br>
        <hr></hr>
             <FormGroup row className={classes.formgroup}>
             <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="budget">Budget</InputLabel>
                    <Select
                      value={searchData.budget}
                      className={classes.textField}
                      labelId="budget"
                      onChange={(e) =>setsearchData({ ...searchData,budget: e.target.value,})}
                    >
                      <MenuItem value={"Cheapest"}> Cheapest</MenuItem>
                      <MenuItem value={"Low"}>Low</MenuItem>
                      <MenuItem value={"Medium"}>Medium</MenuItem>
                      <MenuItem value={"High"}>High</MenuItem>
                      <MenuItem value={"Luxury"}>Luxury</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="type">Type</InputLabel>
                    <Select
                    
                      value={searchData.type}
                      className={classes.textField}
                      labelId="type"
                      onChange={(e) =>setsearchData({ ...searchData,type: e.target.value,})}
                    >
                      <MenuItem value={"Romantic"}>Romantic</MenuItem>
                      <MenuItem value={"Family with kids"}>Family with kids</MenuItem>
                      <MenuItem value={"Family without kids"}>Family without kids</MenuItem>
                      <MenuItem value={"Party lovers"}>Party lovers</MenuItem>
                      <MenuItem value={"Adventure junkies"}>Adventure junkies</MenuItem>
                      <MenuItem value={"Generic"}>Generic</MenuItem>
                    </Select>
                  </FormControl>
            {showspecial.length>0?(
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="special">Special</InputLabel>
                    <Select
                    
                      value={searchData.special}
                      className={classes.textField}
                      labelId="special"
                      onChange={(e) =>setsearchData({ ...searchData,special: e.target.value,})}
                    >
                     {showspecial.map(item=>
                      <MenuItem value={item}>{item}</MenuItem>
                     )}
                    </Select>
                  </FormControl>
                  ):("")}
                  <Button
                onClick={searchquote}
                variant="outlined"
                color="inherit"
                className={classes.button}
              >
                Get Quote
              </Button>
             </FormGroup>
            
        </Paper>
        </div>
        )}
        </div>
    )
}

export default ProductBased;